const api = {
  state: {
    // 全局变量接口
    api: {
      GLOBAL_ENV: process.env.NODE_ENV === 'development',
      /**
       * 图片URL地址前缀,从浏览器地址栏获取URL前缀,如:http://xxx.qstamper.com:8080/user/addUser ---> http://xxx.qstamper.com:8080
       */
      GLOBAL_HOST: window.location.href.match(/((.*?)\/\/(.*?))\//)[1],
      /**
       * 设备相关
       */
      GLOBAL_device_online_size: "/device/config/getOnlineSize", //在线设备列表
      /**
       * 区块链相关
       */
      GLOBAL_device_block_chain_find_one_result: '/blockchain/findResultByInfoId',  // 查询使用记录的区块链验真码
      GLOBAL_device_retry_to_chain: '/blockchain/toChain', // 重试上链
      /**
       * 日志相关
       */
      GLOBAL_log_logger_list: "/proxy/operation/logger/findList",  // 日志列表
      GLOBAL_log_logger_object_list: "/proxy/operation/loggerObject/findList",  // 日志列表
      GLOBAL_log_logger_attribute_list: "/proxy/operation/loggerAttribute/findList",  // 属性列表
      GLOBAL_log_detail_list: "/proxy/operation/logger/attribute/findByLogger",  // 日志详情
      GLOBAL_log_history_options: '/log/findEnumList',   // 搜索项列表
      /**
       * 申请单相关
       */
      GLOBAL_application_list: '/application/application/findApplicationList',

      /**
       * OCR服务相关
       */
      GLOBAL_ocr_apis_ocrResult_findByBizId: "/ocr/ocrResult/findRatioByBizId", // 查询OCR解析结果
      GLOBAL_ocr_create_client: "/ocr/ocrClient/create", // 创建OCR客户端
      GLOBAL_ocr_edit_client: "/ocr/ocrClient/edit", // 编辑OCR客户端
      GLOBAL_ocr_delete_client: "/ocr/ocrClient/delete", // 删除OCR客户端
      GLOBAL_ocr_client_list: "/ocr/ocrClient/findList",      // 查询OCR客户端列表
      GLOBAL_ocr_tenant_list: "/ocr/ocrTenant/findList",      // 查询OCR客户端的租户列表
      GLOBAL_ocr_edit_tenant: "/ocr/ocrTenant/edit",        // 编辑租户信息
      GLOBAL_ocr_result_find: "/ocr/ocrResult/findByBizId", // 查询OCR文件解析结果
      GLOBAL_ocr_compare_result: "/ocr/ocrResult/findCompareResult",   // 查询申请单的使用记录文本相似度对比结果
      GLOBAL_ocr_result_post: '/ocrCompareResult/handleOcrCompare',     // OCR提交审核
      GLOBAL_ocr_edit_threshold: '/deviceThreshold/editByDevice',      // OCR告警值更新
      GLOBAL_ocr_threshold_find: '/deviceThreshold/findOcrThreshold',   // OCR告警值查询

      /**
       * 高拍仪相关
       */
      GLOBAL_meter_find_list: '/device/meter/findList',     // 获取高拍仪列表
      GLOBAL_meter_insert: '/device/meter/create',          // 新增高拍仪
      GLOBAL_meter_edit: '/device/meter/edit',              // 更新高拍仪
      GLOBAL_meter_remove: '/device/meter/remove',          // 删除高拍仪

      //扩展配置
      GLOBAL_config_extension_update: "/config/extension/update", //扩展配置
      GLOBAL_perms_getRoute: "/auth/perms/getRoute", //动态菜单
      GLOBAL_signet_unlock: "/device/signet/unlock", //手动解锁
      GLOBAL_device_signet_queryLocation: "/device/signet/queryLocation", //获取地图印章位置
      GLOBAL_auth_appRotationImg_add: "/auth/appRotationImg/add", //增加轮播图
      GLOBAL_auth_appRotationImg_getAll: "/auth/appRotationImg/getAll", //查询已配置的轮播图列表
      GLOBAL_auth_appRotationImg_del: "/auth/appRotationImg/del", //删除轮播图
      GLOBAL_auth_user_isDirector: "/auth/user/isDirector", //获取用户权限
      GLOBAL_key_randomPubKey: "/key/randomPubKey", //获取rsa公钥
      GLOBAL_file_fileInfo_checkFilesize: "/file/fileInfo/checkFilesize", //上传判断文件大小
      //职称相关
      GLOBAL_auth_position_getAllPositionList: "/auth/position/getAllPositionList", //查询职称列表
      GLOBAL_auth_position_delPosition: "/auth/position/delPosition", //删除职称
      GLOBAL_auth_position_addPosition: "/auth/position/addPosition", //添加职称
      //使用记录
      GLOBAL_device_seal_record_info_getInfoByApplicationId: "/device/seal_record_info/getInfoByApplicationId", //查询申请单使用记录
      //组织相关
      GLOBAL_auth_org_getOrgsByPhone: "/auth/org/getOrgsByPhone", //获取指定手机号所在的公司列表
      GLOBAL_auth_org_getOrgTree: "/auth/org/getOrgTree", //查询登录用户组织树
      GLOBAL_auth_org_getOrganizationalTreeNode: "/auth/org/getOrganizationalTreeNode", //查询组织架构树节点信息
      GLOBAL_auth_department_getDepartmentsByLogin: '/auth/department/getDepartmentsByLogin', //查询用户所属组织列表
      //员工相关
      GLOBAL_auth_user_getEmployeeForManagerByDepartmentId: "/auth/user/getEmployeeForManagerByDepartmentId", //查询可作为集团(企业、部门)负责人的员工列表
      GLOBAL_auth_user_addEmployee: "/auth/user/addEmployee", //添加员工
      GLOBAL_auth_user_changeOrg: "/auth/user/changeOrg", //切换组织
      //公司部门相关
      GLOBAL_auth_department_getLevelsByOrgForAddAndUpdateEmployee: "/auth/department/getLevelsByOrgForAddAndUpdateEmployee", //查询织架构(级联形式)用于添加(更新)员工信息
      GLOBAL_auth_department_getParents: "/auth/department/getParents", //查询可作为企业(部门)父组织的组织列表
      GLOBAL_auth_org_getOrgsByLogin: "/auth/org/getOrgsByLogin", //查询登录用户拥有的集团列表
      GLOBAL_auth_org_regV2: "/auth/org/regV2", //注册组织
      GLOBAL_auth_department_getLevelsByOrgForAddAndUpdateFlow: "/auth/department/getLevelsByOrgForAddAndUpdateFlow",
      GLOBAL_auth_department_addDepartment: "/auth/department/addDepartment", //添加企业、团队、组织
      GLOBAL_auth_department_delDepartment: "/auth/department/delDepartment", //删除企业、团队、组织
      GLOBAL_auth_department_updateDepartment: "/auth/department/updateDepartment", //修改企业、团队、组织
      GLOBAL_auth_notice_getDisassemblyRecordInfoList: "/auth/notice/getDisassemblyRecordInfoList", //拉取设备拆卸通知弹出消息列表
      //配置管理
      GLOBAL_device_userConfig_getList: "/device/userConfig/getList", //查询本公司所有印章配置列表
      GLOBAL_device_userConfig_updateConfig: "/device/userConfig/updateConfig", //修改配置信息
      GLOBAL_device_finger_searchFingers: "/device/finger/searchFingers", //查询用户拥有的指纹列表
      //印章监控系统
      GLOBAL_device_detail_searchSignetDetailList: "/device/detail/searchSignetDetailList", //设备概况
      GLOBAL_device_detail_searchAddrDetails: "/device/detail/searchAddrDetails", //印章运动轨迹
      GLOBAL_device_detail_searchDeviceDetails: "/device/detail/searchDeviceDetails", //查询设备操作日志
      GLOBAL_device_detail_getCmds: "/device/detail/getCmds", //查询指令码列表接口
      GLOBAL_device_disassemblyRecordInfo_getInfoByNoticeId: "/device/disassemblyRecordInfo/getInfoByNoticeId", //查看(设备拆卸)系统消息详情
      GLOBAL_device_sealRecordInfo_blankOutInfo: "/device/sealRecordInfo/customRemark", //使用记录作废

      GLOBAL_loginURI: "/auth/user/loginV1", //登录接口（密码登录）
      GLOBAL_user_loginV2: "/auth/user/loginV2", //登录接口（手机号登录）
      GLOBAL_getPhoneCode: "/auth/user/getPhoneCode", //获取手机验证码
      GLOBAL_user_getRandomCode: "/auth/user/getRandomCode", //获取图形验证码
      doubleGetPhoneCode: "/auth/user/doubleGetPhoneCode", //登录双因子发送短信验证码
      GLOBAL_LOGIN_GIF: "/auth/user/getGifCode", //动态码
      GLOBAL_user_logout: "/auth/user/logout", //用户登出
      GLOBAL_user_getShortcutAll: "/auth/user/getShortcutAll", //获取全部快捷方式
      GLOBAL_user_getShortcuts: "/auth/user/getShortcuts", //获取用户已经设置的快捷方式
      GLOBAL_user_updateShortcut: "/auth/user/updateShortcut", //更新设置的快捷方式
      //我的面板
      GLOBAL_myuserInfo: "/auth/user/get", //获取用户信息
      GLOBAL_myuserUpdate: "/auth/user/myUpdate", //修改用户资料
      GLOBAL_user_changePasswordV1: "/auth/user/changePasswordV1", //修改密码
      GLOBAL_personalNotices: "/auth/notice/getNoticesByUser", //系统消息
      GLOBAL_resetPassword: "/auth/user/resetPwd", //重置密码
      GLOBAL_application_getByOwnerApplications: "/application/application/getByOwnerApplications", //我的申请
      GLOBAL_application_getByMyApplication: "/application/application/getByMyApplication", //查询申请单详情
      GLOBAL_application_cancelApplication: "/application/application/cancelApplication", //取消申请单
      GLOBAL_application_exitApplication: "/application/application/exitApplication", //结束用章
      //查看当前系统消息
      GLOBAL_ckeckNotice: "/auth/notice/checkNotice", //点击查看当前系统消息
      //平台管理
      GLOBAL_permsadd: "/auth/perms/add", //添加权限
      GLOBAL_perms_update: "/auth/perms/update", //编辑
      GLOBAL_getTree: '/auth/perms/getTree', //权限树
      GLOBAL_permsgetAll: '/auth/perms/getAll', //获取所有权限
      GLOBAL_permsgetdel: '/auth/perms/del', //删除节点权限
      GLOBAL_flow_add: '/application/flow/add', //添加审批流程
      GLOBAL_device_cameraSwitch: '/device/signet/cameraSwitch',//摄像头开启关闭
      GLOBAL_device_witch_high_profile_camera: '/device/signet/switchHighProfileCamera',//高拍仪开启关闭
      //组织架构
      GLOBAL_org_getOrganizationalToSelectSignet: '/auth/org/getOrganizationalToSelectSignet', //查询登录用户所属公司组织架构
      GLOBAL_org_update: '/auth/org/updateOrg', //编辑完成
      GLOBAL_user_getV2: '/auth/user/getV2', //获取管理员账号名字
      GLOBAL_org_getChildrens: '/auth/org/getChildrens', //获取子公司列表
      //部门管理
      GLOBAL_department_getTree: '/auth/department/getTree', //获取部门列表树
      GLOBAL_department_add: '/auth/department/add', //添加部门
      GLOBAL_department_del: '/auth/department/del', //删除部门
      GLOBAL_user_getUsers: '/auth/user/getUsers', //获取当前公司员工
      GLOBAL_department_update: '/auth/department/update', //部门更新
      GLOBAL_department_getListByOrg: '/auth/department/getListByOrg', //查询该公司下所有部门列表
      //用户组管理
      GLOBAL_userGroup_getByDepartment: '/auth/userGroup/getByDepartment', //获取用户组列表/userGroup/add
      GLOBAL_userGroup_add: '/auth/userGroup/add', //添加用户组
      GLOBAL_userGroup_update: '/auth/userGroup/update', //更新编辑行
      GLOBAL_userGroup_del: '/auth/userGroup/del', //删除
      GLOBAL_user_getUsersByUserGroup: '/auth/user/getUsersByUserGroup', //查看用户组成员
      GLOBAL_department_getLevelsByOrg: '/auth/department/getLevelsByOrg', //查询该公司下所有部门(以级联层级结构展示)
      GLOBAL_department_getLevelsByOrgToUpdateSignet: '/auth/department/getLevelsByOrgToUpdateSignet', //查询该公司下所有部门(以级联层级结构展示)
      GLOBAL_auth_department_getOrgTreeByUpdateSignet: '/auth/department/getLevelsByOrgToUpdateSignet', //编辑时获取设备所属组织
      //查看原图
      GLOBAL_file_fileInfo_getOriginalPictureURLByFileId: '/file/fileInfo/getOriginalPictureURLByFileId', //查询指定文件的访问路径URL
      // 角色管理
      GLOBAL_role_getByOrg: '/auth/role/getByOrg', //获取角色列表
      GLOBAL_role_getByUser: '/auth/role/getByUser', //搜索
      GLOBAL_role_add: '/auth/role/add', //添加
      GLOBAL_role_update: '/auth/role/update', //更新编辑行
      GLOBAL_role_del: '/auth/role/del', //删除
      GLOBAL_rolePerms_getByRole: '/auth/rolePerms/getByRole', //获取树的权限列表
      GLOBAL_rolePerms_bindPerms: '/auth/rolePerms/bindPerms', //点击树完成
      GLOBAL_role_searchByRole: '/auth/role/searchByRoleWeb', //搜索
      //人员管理
      GLOBAL_user_getByOrg: '/auth/user/getByOrg', //获取人员列表
      GLOBAL_user_update: '/auth/user/update', //更新编辑行
      GLOBAL_user_del: '/auth/user/del', //删除人员
      GLOBAL_application_applicationNode_fastTrans: '/application/applicationNode/fastTrans', //转交人员
      GLOBAL_user_activation: '/auth/user/activation', //激活
      GLOBAL_user_searchByOrgAndKeywords: '/auth/user/searchByOrgAndKeywords', //搜索
      GLOBAL_user_resetPassword: '/auth/user/resetPassword', //员工重置密码
      //用户注册
      GLOBAL_user_regist: '/auth/user/reg', //编辑完成
      GLOBAL_user_checkPhone: '/auth/user/checkPhone', //校验手机号是否在系统中已存在
      //系统管理
      GLOBAL_sysOrg_getByOwner: '/auth/smsOrg/getByOwner',//获取短信通知模板
      GLOBAL_orgNotice_getByOwner: '/auth/orgNotice/getByOwner',//获APP通知模板
      GLOBAL_sysOrg_changeSms: '/auth/smsOrg/update',//开启关闭短信通知
      GLOBAL_orgNotice_update: '/auth/orgNotice/update',//开启关闭App通知
      GLOBAL_auth_smsOrg_updateBulk: '/auth/smsOrg/updateBulk', //批量启用、禁用
      GLOBAL_auth_orgNotice_updateBulk: '/auth/orgNotice/updateBulk', //批量启用、禁用
      //申请用章
      GLOBAL_application_add: '/application/application/add', //创建申请单
      GLOBAL_fileTemp_uploadFile: '/file/fileInfo/uploadFile', //单文件上传文件、附件
      GLOBAL_fileTemp_uploadAndGetFile: '/file/fileInfo/uploadAndGetFile', //单文件上传文件、附件返回url
      GLOBAL_config_addOrUpdateVersion: '/device/config/addOrUpdateVersion', //更新apk地址
      GLOBAL_configVersion_getList: '/device/configVersion/getList', //查询设备apk版本列表
      GLOBAL_configVersion_findList: '/device/configVersion/findList', //查询设备apk版本列表
      GLOBAL_configVersion_add: '/device/configVersion/add', //设备添加新版本APK
      GLOBAL_configVersion_insert: '/device/configVersion/insert', //设备添加新版本APK
      GLOBAL_configVersion_edit: '/device/configVersion/edit', //设备添加新版本APK
      GLOBAL_configVersion_delete: '/device/configVersion/delete', //设备删除指定版本APK
      GLOBAL_configVersion_del: '/device/configVersion/del', //设备删除指定版本APK
      GLOBAL_config_getDefaultConfig: '/device/config/getDefaultConfig', //查询全局配置
      GLOBAL_config_getLogByUUID: '/device/config/getLogByUUID', //查看日志列表
      GLOBAL_config_reset: '/device/config/reset', //查看日志列表

      GLOBAL_user_getManagers: '/auth/user/getManagers', //获取所有审批人数据
      GLOBAL_user_getOrganizationalToApplicationForm: '/auth/user/getOrganizationalToApplicationForm', //查询审批人列表
      GLOBAL_user_getOrganizationalToAddFlow: '/auth/user/getOrganizationalToAddFlow', //查询审批人列表
      GLOBAL_auth_user_userListForReport: '/auth/user/userListForReport', //用户列表
      //审批
      GLOBAL_application_getNotApprovedByOwn: '/application/application/getNotApprovedByOwn', //获取待审批列表
      GLOBAL_application_getApprovedByOwn: '/application/application/getApprovedByOwn', //获取已审批列表
      GLOBAL_application_getManagerApplicationById: '/application/application/getManagerApplicationById', //审批处理详情
      GLOBAL_applicationManager_managerOK: '/application/applicationNode/managerOK', //审批同意
      GLOBAL_applicationManager_managerFail: '/application/applicationNode/managerFail', //审批驳回
      GLOBAL_applicationManager_managerTrans: '/application/applicationNode/managerTrans', //审批转交中
      GLOBAL_application_applicationNode_getNextOptionalNode: '/application/applicationNode/getNextOptionalNode', //自选
      //授权
      GLOBAL_application_getUnAuthorizedByOwn: '/application/application/getUnAuthorizedByOwn', //获取待授权列表
      GLOBAL_application_getAuthorizedByOwn: '/application/application/getAuthorizedByOwn', //获取已授权列表
      GLOBAL_application_getKeeperApplicationById: '/application/application/getKeeperApplicationById', //授权处理详情
      GLOBAL_applicationKeeper_keeperOK: '/application/applicationNode/keeperOK', //授权同意
      GLOBAL_applicationKeeper_KeeperFAIL: '/application/applicationNode/keeperFAIL', //授权拒绝
      GLOBAL_applicationKeeper_pushApplicationToSignet: '/application/application/pushApplicationToSignet', //授权推送
      GLOBAL_applicationKeeper_endApplicationToSignet: '/application/application/endApplicationToSignet', //推送结束
      //审计
      GLOBAL_application_getNotAuditedByOwn: '/application/application/getNotAuditedByOwn', //获取待审计列表
      GLOBAL_application_getAuditedByOwn: '/application/application/getAuditedByOwn', //获取已审计列表
      GLOBAL_application_getAuditorApplicationById: '/application/application/getAuditorApplicationById', //审计处理详情
      GLOBAL_applicationAuditor_auditorOK: '/application/applicationNode/auditorOK', //正常
      GLOBAL_applicationAuditor_auditorFAIL: '/application/applicationNode/auditorFAIL', //异常
      GLOBAL_applicationDealLog_getByApplication: '/application/applicationNode/getByApplication', //获取审批流程
      GLOBAL_sealRecordInfo_getByApplicationId: '/device/sealRecordInfo/getByApplicationId', //获取审批流程
      GLOBAL_sealRecordInfo_getById: '/device/sealRecordInfo/getById', //查看使用记录详情
      //使用记录
      GLOBAL_sealRecordInfo_searchInfoList: '/device/sealRecordInfo/searchInfoListByKeyword', //模糊查询
      GLOBAL_application_getBySealRecordInfoToBind: '/application/application/getBySealRecordInfoToBind',//查询指定使用记录可以绑定的申请单列表
      GLOBAL_sealRecordInfo_banding: '/device/sealRecordInfo/banding',//绑定申请单
      GLOBAL_report_applicationReport: '/device/report/applicationReport',//申请报表
      GLOBAL_report_getReport: '/device/report/getReport',//查询登录用户报表列表
      GLOBAL_report_del: '/device/report/del',//删除报表
      //设备管理
      GLOBAL_signet_getByOrg: '/device/signet/getByOrg',//查询当前登录用户公司印章列表
      GLOBAL_signet_getByOwner: '/device/signet/getByOwner', //查询当前登录用户公司(及子公司)印章列表
      GLOBAL_signet_getBySignet: '/device/signet/getBySignet', //印章详细信息
      GLOBAL_auth_user_getAuditorsByUpdateDevice: '/auth/user/getAuditorsByUpdateDevice', //查询可作为'印章审计员'员工列表
      GLOBAL_auth_user_getKeepersToUpdateDevice: '/auth/user/getKeepersToUpdateDevice', //查询可作为'印章管理员'员工列表
      GLOBAL_signet_del: '/device/signet/del', //删除印章
      GLOBAL_signet_initializtion: '/device/signet/initializtion', //清除次数
      GLOBAL_signet_migrate: '/device/signet/migrate', //迁移印章
      GLOBAL_user_getFingerUserBySignet: '/auth/user/getFingerUserBySignet', //查询未录入的用户列表信息
      GLOBAL_finger_fingerPrint: '/device/finger/fingerPrint', //指纹录入
      GLOBAL_finger_cleanOne: '/device/finger/cleanOne', //指纹删除
      GLOBAL_finger_cleanAll: '/device/finger/cleanAll', //指纹全部清空
      GLOBAL_signet_update: '/device/signet/update', //编辑完成
      GLOBAL_deviceType_getByOrg: '/device/deviceType/getByOrg', //获取印章类别
      GLOBAL_sealRecordInfo_getBySignetId: '/device/sealRecordInfo/getBySignetId', //使用记录

      GLOBAL_signet_getWifiList: '/device/signet/getWifiList', //查询印章附件wifi列表
      GLOBAL_signet_setWifiLink: '/device/signet/setWifiLink', //wifi连接
      GLOBAL_signet_closeWifi: '/device/signet/closeWifi', //wifi断开
      GLOBAL_signet_getLogFile: '/device/signet/getLogFile', //通知设备上传日志文件
      GLOBAL_device_signet_setDormancy: '/device/signet/setDormancy', //设置印章休眠时间
      GLOBAL_device_signet_openPatternFinger: '/device/signet/openPatternFinger', //开启指纹模式
      GLOBAL_device_signet_setRemoteLock: '/device/signet/setRemoteLock', //远程锁定
      GLOBAL_device_signet_installationChapterHead: '/device/signet/installationChapterHead', //远程装章
      GLOBAL_device_signet_deviceListForReport: '/device/signet/deviceListForReport', //获取印章列表
      GLOBAL_device_report_getReportList: '/device/report/getReportList', //查询报表列表记录
      GLOBAL_device_config_enabledApplication: '/device/config/enabledApplication', //设备使能_申请单
      GLOBAL_device_config_enabledProductionTest: '/device/config/enabledProductionTest', //设备使能_产测
      GLOBAL_device_config_enabledList: '/device/config/enabledList', //设备使能_产测
      // 数据统计
      GLOBAL_report_getStatistics: '/device/report/getStatistics',//查询公司 申请单总数/使用记录总数/印章总数
      GLOBAL_report_getHistogram: '/device/report/getHistogram',//查询该公司各印章使用总次数(柱状图)
      GLOBAL_report_getMapChart: '/device/report/getMapChart',//查询该公司各印章使用总次数(地图)
      GLOBAL_report_getErrorOrNormal: '/device/report/getErrorOrNormal',//异常/正常/警告(饼状图)
      GLOBAL_signet_getTotalByOnline: '/device/report/getTotalByOnline',//在线印章数,及总数(仪表图)
      //平台
      GLOBAL_orgServe_getAll: '/auth/orgServe/getAll',//获取组织的信息
      GLOBAL_orgServe_updateSMS: '/auth/orgServe/updateSMS',//更新短信服务
      GLOBAL_orgServe_updateDevice: '/auth/orgServe/updateDevice',//更新基础服务
      GLOBAL_orgServe_updateOOS: '/auth/orgServe/updateOOS',//上传天翼云
      GLOBAL_orgServe_updateQSS: '/auth/orgServe/updateQSS',//更新公司量子服务
      GLOBAL_qss_getAll: '/auth/qss/getAll',//查询所有量子加解密URL列表
      GLOBAL_qss_del: '/auth/qss/del',//删除对应量子加解密URL
      GLOBAL_qss_add: '/auth/qss/add',//添加量子加密URL
      GLOBAL_qss_update: '/auth/qss/update',//编辑量子加密URL
      GLOBAL_qss_getByArray: '/auth/qss/getByArray',//查询所有量子加解密URL数组
      GLOBAL_messageTemp_getAll: '/auth/messageTemp/getAll',//查询通知/短信模板配置列表
      GLOBAL_noticeTemp_getList: '/auth/noticeTemp/getList',//查询通知模板列表
      GLOBAL_smsTemp_getList: '/auth/smsTemp/getList',//查询短信模板列表
      GLOBAL_messageTemp_update: '/auth/messageTemp/update',//更新 短信/通知模板配置
      GLOBAL_appVersion_add: '/auth/appVersion/add',//app版本更新
      GLOBAL_appVersion_del: '/auth/appVersion/del',//app版本删除
      GLOBAL_appVersion_getAll: '/auth/appVersion/getAll',//app版本列表
      GLOBAL_device_log_getLogByDeviceIdAndUseCount: '/device/log/getLogByDeviceIdAndUseCount',//异常信息捕获
      GLOBAL_device_deviceMigrateLog_getList: '/deviceMigrateLog/getList',//迁章记录
      //首页
      GLOBAL_userLogger_getByUser: '/auth/userLogger/getByUser',//查询最近使用日志列表
      GLOBAL_org_getByOwner: '/auth/org/getByOwner',//查询登录用户公司信息
      GLOBAL_application_getDataByOwner: '/application/application/getDataByOwner',//查询登录用户待审计/待审批/待授权/待处理申请单 信息
      //流程管理
      GLOBAL_flow_getByOwner: '/application/flow/getByOwner',//查询登录用户审批流程列表(类型名称,审批人列表)
      GLOBAL_flow_getAll: '/application/flow/getAll',//查询登录用户审批流程列表(类型名称,审批人列表)
      GLOBAL_flow_getVo: '/application/flow/getVo',//编辑时,查询审批流程图实例
      GLOBAL_flow_updateNodes: '/application/flow/updateNodes',//修改审批流程图
      GLOBAL_flow_update: '/application/flow/update',//修改审批流程
      GLOBAL_flow_del: '/application/flow/del',//删除审批流程
      //密码策略
      GLOBAL_strategypassword_get: '/auth/strategypassword/get',//获取当前公司的密码策略
      GLOBAL_strategypassword_update: '/auth/strategypassword/update',//修改当前公司的密码策略
      GLOBAL_strategypassword_getTips: '/auth/strategypassword/getTips',//获取当前密码策略提示信息
      //阈值
      GLOBAL_signet_getThresholds: '/device/signet/getThresholds',//获取所有设备的阈值
      GLOBAL_signet_getThresholdInfo: '/device/signet/getThresholdInfo',//获取当前设备阈值信息
      GLOBAL_signet_updateThreshold: '/device/signet/updateThreshold',//修改设备阈值信息
      //印章配置
      GLOBAL_config_getConfigList: '/device/config/getConfigList',//获取平台所有印章配置列表信息
      GLOBAL_config_addOrUpdateConfig: '/device/config/addOrUpdateConfig',//添加/更新 印章的配置信息
      //微信小程序相关
      GLOBAL_wechat_control_add: '/wechat/control/add',//添加小程序
      GLOBAL_wechat_control_list: '/wechat/control/list',//小程序列表
      GLOBAL_wechat_control_delete: '/wechat/control/delete',//删除
      GLOBAL_wechat_control_update: '/wechat/control/update',//更新
      //导出申请单相关
      GLOBAL_auth_user_userList: '/auth/user/userList',//员工列表
      GLOBAL_device_signet_deviceList: '/device/signet/deviceList',//设备列表
      GLOBAL_application_application_statusList: '/application/application/statusList',//申请单状态列表
      GLOBAL_device_report_applicationFormList: '/device/report/applicationFormList',//查询报表列表记录
    }
  },
  mutations: {
    SET_BREADCRUMB: (state, breadcrumb) => {
      state.breadcrumb = breadcrumb
    },
  },
  actions: {
    SET_BREADCRUMB({
                     commit
                   }, userInfo) {
      return new Promise((resolve, reject) => {
        commit('SET_BREADCRUMB')
        resolve()
      })
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/store/modules/api.js